import BaseEntity from '../baseclasses/BaseEntity'
export class EquipmentClass extends BaseEntity {
    ID?: number;
    Name?: string;
}

export default EquipmentClass;